module.exports = __webpack_public_path__ + "images/places/training_773-cf8ba20b35d6d2dae8a1497f51dae93b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_773.jpg
 ** module id = 331
 ** module chunks = 0
 **/